module.exports = __webpack_public_path__ + "img/pr-20.b21f1cc5.png";